import { defineStore } from 'pinia'

/**
 * Converted from store/notification.js.
 *
 * The module-level `nextId` counter comes across as-is: it is deliberately NOT
 * state, so it keeps counting across a $reset and never lands in a persisted
 * blob. Ids only have to be unique within a session.
 *
 * This module has no getters — NotificationContainer/NotificationBar read it
 * through Pinia's mapState/mapActions instead.
 */
export interface INotification {
  id?: number
  type?: string
  message?: string
  [key: string]: unknown
}

let nextId = 1

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    notifications: [] as INotification[],
  }),
  actions: {
    add(notification: INotification): void {
      this.notifications.push({ ...notification, id: nextId++ })
    },
    remove(notificationToRemove: INotification): void {
      this.notifications = this.notifications.filter(
        (notification) => notification.id !== notificationToRemove.id
      )
    },
    removeWhere(predicate: (notification: INotification) => boolean): void {
      this.notifications = this.notifications.filter(
        (notification) => !predicate(notification)
      )
    },
  },
})
